import React, { useContext, useEffect, useState } from 'react';
import cl from './ContainerEditModal.module.css' 
import Container from "../../../../assets/Icon/Container";
import BLicon from "../../../../assets/Icon/BLicon";
import BookingNum from "../../../../assets/Icon/BookingNum"; 
import Seal from "../../../../assets/Icon/Seal"; 
import Number from "../../../../assets/Icon/Number";  
import Kilogram from '../../../../assets/Icon/Kilogram';
import Ship from "../../../../assets/Icon/Ship";
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import { selectDistatntionStyle } from './selectDistatntionStyle';
import Select from "react-select"; 
import DistatntionSelect from './DistatntionSelect';
import DateSelect from '../../../UI/Inputs/DateSelect';
import { useClient } from '../../../../hooks/useClient';
import USD from '../../../../assets/Icon/USD';
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect';


const EditContainerModal = ({ containerService, defaultContainer, onCloseEdit, onUpdateClientPrice, onUpdateCompanyPrice }) => {
   
    const containerResetData = {
        id: defaultContainer.id,
        container_number: defaultContainer.container_number,
        bl_number: defaultContainer.bl_number,
        booking_number: defaultContainer.booking_number,
        ship_name: defaultContainer.ship_name, 


        frast_price: defaultContainer.frast_price,
        thc_price: defaultContainer.thc_price,
        other_price: defaultContainer.other_price,
        land_price:  defaultContainer.land_price,
        total_price:  defaultContainer.total_price,
        client_total_price:  defaultContainer.client_total_price,

        land_other_price: defaultContainer.land_other_price,

        is_transit: defaultContainer.is_transit,

        client_land_price: defaultContainer.client_land_price,
        client_other_price: defaultContainer.client_other_price,
        client_frast_price: defaultContainer.client_frast_price,
        client_thc_price: defaultContainer.client_thc_price, 
        client_land_other_price: defaultContainer.client_land_other_price,

        land_type_id: defaultContainer.land_type_id,

        sender_city_id:  defaultContainer.sender_city?.id || 0,
        reciever_city_id: defaultContainer.reciever_city?.id || 0,
        sender_country_id: defaultContainer.sender_country?.id || 0,
        reciever_country_id: defaultContainer.reciever_country?.id || 0,
        agent_id:  defaultContainer.agent?.id || 0,

        final_destination_country_id: defaultContainer.final_destination_country?.id || 0,
        final_destination_city_id:  defaultContainer.final_destination_city?.id || 0,

        shipper_id: defaultContainer.shipper?.id || 0,
        send_at: defaultContainer.send_at, 
        open_at:defaultContainer.open_at,
        taken_at:defaultContainer.taken_at,
        entry_at:defaultContainer.entry_at,
        seal_number:defaultContainer.seal_number,
        voyage_number:defaultContainer.voyage_number,
        gross_weight:defaultContainer.gross_weight,

        status_id: defaultContainer.status_id,
        land_price: defaultContainer.land_price,
        frast_price: defaultContainer.frast_price,
        thc_price: defaultContainer.thc_price,

        marine_line_id: defaultContainer.marine_line_id, 
    }

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', 
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }), 
    };
 
    const [newContainer, setNewContainer] = useState(containerResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);
    const shippers = appState.shippers.map((shipper) => ({ value: shipper.id, label: shipper.name }));
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name })); 

    const typeOptions = appState.initialTypeOptions;

    const initialTransitOptions = [
        { value: 0, label: 'არა' },
        { value: 1, label: 'კი' }, 
    ]; 

    const typeTransitOptions = initialTransitOptions;


    const validateContainer = (container) => {
        const messages = {};

       if (container.container_number.length < 2) {
            messages.container_number = { message: 'მიუთითეთ კონტაინერი ნომერი', isValid: false };
        }

        if (container.bl_number.length < 2) {
            messages.bl_number = { message: 'მიუთითეთ bl ნომერი', isValid: false };
        }
 
        if (container.booking_number.length < 2) {
            messages.booking_number = { message: 'მიუთითეთ booking ნომერი', isValid: false };
        }

        if (container.marine_line_id < 1) {
            messages.marine_line_id = { message: 'აირჩიე საზღვაო ხაზი', isValid: false };
        }

        if (container.ship_name.length < 2) {
            messages.ship_name = { message: 'მიუთითეთ გემის სახელი', isValid: false };
        }
 
 
         
  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

 

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateContainer(newContainer)
        }
    }, [newContainer, isFirstValidated]);


   
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

        

    const getTransportPrice = (sender_city_id, receiver_city_id, marine_line_id, agent_id, send_at) => {
        console.log(appState.container_prices);
    
        return new Promise((resolve, reject) => {
            // Convert send_at to a Date object
            const sendDate = new Date(send_at);
            console.log('არჩეული თარიღი '+ sendDate);

            var initialResult = appState.container_prices.find(
                (obj) => {

                    const periodStartAt = new Date(obj.period_start_at);
                    const periodEndAt = new Date(obj.period_end_at);
                    console.log(periodStartAt);
                    console.log(periodEndAt);

                    return (
                        obj.sender_city.id === sender_city_id &&
                        obj.reciever_city.id === receiver_city_id &&
                        obj.marine_line.id === marine_line_id &&
                        obj.agent.id === agent_id &&
                        (periodStartAt <= sendDate && periodEndAt >= sendDate)
                    );
                }
            );
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            } else {
                resolve(initialResult); 
            }
        });
    };

    const getTransportPriceExtra = (sender_city_id, receiver_city_id, land_type_id, agent_id, send_at) => {
        console.log(appState.container_prices);
    
        return new Promise((resolve, reject) => {
            const sendDate = new Date(send_at);
            console.log('არჩეული თარიღი: ' + sendDate);
    
            var initialResult = appState.container_prices.find(
                (obj) => {

                    const periodStartAt = new Date(obj.period_start_at);
                    const periodEndAt = new Date(obj.period_end_at);
    
                    return (
                        obj.sender_city.id === sender_city_id &&
                        obj.reciever_city.id === receiver_city_id &&
                        obj.type_id === land_type_id &&
                        obj.agent.id === agent_id &&
                        (periodStartAt <= sendDate && periodEndAt >= sendDate)
                    );
                }
            );
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            } else {
                resolve(initialResult);
            }
        });
    };



 

    const handleonUpdateClientPrice = (priceClient) => {  
        onUpdateClientPrice(priceClient);
    };

    const handleonUpdateCompanyPrice = (priceCompany) => {  
        onUpdateCompanyPrice(priceCompany);
    };


    useUpdateEffect(() => {
        const updatePrices = async () => {
            let clientOceanPrice = 0;
            let companyOceanPrice = 0;
            let clientLandPrice = 0;
            let companyLandPrice = 0;
    
            if (newContainer.sender_city_id > 0 || newContainer.send_at.length > 1) { 
                let reciever = newContainer.reciever_city_id;
    
                try {
                    const priceResponse = await getTransportPrice(newContainer.sender_city_id, reciever, newContainer.marine_line_id, newContainer.agent_id, newContainer.send_at);
                    
                    setNewContainer(prevState => ({
                        ...prevState,
                        thc_price: priceResponse.thc_price,
                        frast_price: priceResponse.frast_price, 
                        other_price: priceResponse.other_price, 
                        client_thc_price: priceResponse.client_thc_price,
                        client_frast_price: priceResponse.client_frast_price, 
                        client_other_price: priceResponse.client_other_price, 
                    }));
    
                    clientOceanPrice = priceResponse.client_thc_price + priceResponse.client_frast_price + priceResponse.client_other_price;
                    companyOceanPrice = priceResponse.thc_price + priceResponse.frast_price + priceResponse.other_price;
                } catch (err) {
                    setNewContainer(prevState => ({
                        ...prevState,
                        thc_price: 0,
                        frast_price: 0, 
                        other_price: 0, 
                        client_thc_price: 0,
                        client_frast_price: 0, 
                        client_other_price: 0, 
                    })); 
    
                    clientOceanPrice = 0;
                    companyOceanPrice = 0;
                }
    
                if (newContainer.final_destination_city_id > 0 || newContainer.send_at.length > 1) {
                    reciever = newContainer.final_destination_city_id;
    
                    try {
                        const priceResponseExtra = await getTransportPriceExtra(newContainer.reciever_city_id, reciever, newContainer.land_type_id, newContainer.agent_id, newContainer.send_at);
                        
                        setNewContainer(prevState => ({
                            ...prevState,
                            land_price: priceResponseExtra.total_price, 
                            land_other_price: priceResponseExtra.other_price, 
                            client_land_price: priceResponseExtra.client_total_price, 
                            client_land_other_price: priceResponseExtra.client_other_price, 
                        }));
    
                        clientLandPrice = priceResponseExtra.client_total_price + priceResponseExtra.client_other_price;
                        companyLandPrice = priceResponseExtra.total_price + priceResponseExtra.other_price;
                    } catch (err) {
                        setNewContainer(prevState => ({
                            ...prevState,
                            land_price: 0, 
                            land_other_price: 0, 
                            client_land_price: 0, 
                            client_land_other_price: 0,
                        })); 
    
                        clientLandPrice = 0;
                        companyLandPrice = 0;
                    }
                }
    
                handleonUpdateClientPrice(clientOceanPrice + clientLandPrice);
                handleonUpdateCompanyPrice(companyOceanPrice + companyLandPrice);
    
                const clientTotalPrice = clientOceanPrice + clientLandPrice;
                const companyTotalPrice = companyOceanPrice + companyLandPrice;
    
                console.log('კლიენტის სახმელეთო ფასი: ' + clientTotalPrice);
                console.log('კომპანიის სახმელეთო ფასი: ' + companyTotalPrice);

             } else {
                /*setNewContainer(prevState => ({
                    ...prevState,
                    land_price: 0,
                    thc_price: 0,
                    frast_price: 0, 
                    other_price: 0, 
                    client_land_price: 0,
                    client_thc_price: 0,
                    client_frast_price: 0, 
                    client_other_price: 0, 
                })); */
            }
        };
    
        updatePrices();
    }, [
        newContainer.reciever_city_id,
        newContainer.sender_city_id,
        newContainer.marine_line_id,
        newContainer.land_type_id,
        newContainer.final_destination_city_id,
        newContainer.agent_id,
        newContainer.send_at
    ]);

    
 

    const saveHandle = () => {

        const isValidate = validateContainer(newContainer)
        var newVar = {
            ...newContainer 
        }
        if (isValidate === true) {
            containerService.update(newVar) 
            onCloseEdit()

        } else {
           // setIsFirstValidated(true)
        }

    };

    const handleContainerChange = async (event) => {
        let val = event.target.value;
        setNewContainer(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const handleContainerChangeInt = async (event) => {
        let val = parseInt(event.target.value, 10); 
        setNewContainer(prevClient => ({
          ...prevClient,
          [event.target.name]: val
        }));
      };

    
    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; 
    
        if (!regex.test(keyValue)) {
          event.preventDefault();
        }
    };

    const handleFocus = (e) => { 
        
        if (e.target.value === '0') {
            setNewContainer({
                ...newContainer,
                [e.target.name]:  ''
              });
        }
    };


    const handleBlur = (e) => { 
        if (e.target.value === '') {
          let val = convertToInt(0);
            setNewContainer({
              ...newContainer,
              [e.target.name]:  val
            });
        };  
       };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    return (
        <>

            <div className={cl.containerItem} style={{ marginBottom: '15px' }}>

                <div className={ validates && validates.container_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS"
                            className={cl.input}
                            id="container_number" name="container_number" value={newContainer.container_number} onChange={handleContainerChange} autoComplete="off" 
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                            />
                        <div className={cl.crmIcon}>
                            <Container />
                        </div>
                    </div>
                    <label htmlFor="container_number">კონტეინერი</label>
                </div>

                <div className={validates && validates.bl_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="bl_number" name="bl_number" 
                        value={newContainer.bl_number} onChange={handleContainerChange} autoComplete="off" 
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        />
                        <div className={cl.crmIcon}>
                            <BLicon />
                        </div>
                    </div>
                    <label htmlFor="bl_number">BL ნომერი</label>
                </div>

                <div className={validates && validates.booking_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="booking_number" name="booking_number" 
                        value={newContainer.booking_number} onChange={handleContainerChange} autoComplete="off"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        />
                        <div className={cl.crmIcon}>
                            <BookingNum />
                        </div>
                    </div>
                    <label htmlFor="booking_number">Booking ნომერი</label>
                </div>

                <div className={validates && validates.seal_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="seal_number" name="seal_number" 
                        value={newContainer.seal_number} onChange={handleContainerChange} autoComplete="off"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        />
                        <div className={cl.crmIcon}>
                            <Seal />
                        </div>
                    </div>
                    <label htmlFor="seal_number">Seal ნომერი</label>
                </div>


                <div className={validates && validates.voyage_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="voyage_number" name="voyage_number" 
                        value={newContainer.voyage_number} onChange={handleContainerChange} autoComplete="off"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        />
                        <div className={cl.crmIcon}>
                            <Number />
                        </div>
                    </div>
                    <label htmlFor="voyage_number">Voyage ნომერი</label>
                </div>


                <div className={validates && validates.ship_name ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="ship_name" name="ship_name" 
                        value={newContainer.ship_name} onChange={handleContainerChange} autoComplete="off" 
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        />
                        <div className={cl.crmIcon}>
                            <Ship />
                        </div>
                    </div>
                    <label >გემის სახელი</label>
                    {validates && validates.personal &&
                        <div className={cl.errorMsg} >{validates.personal.message}</div>}
                </div>

                <div className={validates && validates.shipper_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <Select
                        styles={validates && validates.shipper_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={shippers}
                        placeholder=""
                        isClearable
                        value={shippers.find(option => option.value === newContainer.shipper_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                shipper_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >შიპერი</label>
                </div>
 
                <div className={validates && validates.marine_line_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <Select
                        styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        placeholder=""
                        isClearable
                        options={marines}
                        value={marines.find(option => option.value === newContainer.marine_line_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                marine_line_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >საზღვაო ხაზი</label> 
                </div>


                <div  className={validates && validates.agent_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <Select
                        styles={validates && validates.agent_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        placeholder=""
                        isClearable
                        options={agents}
                        value={agents.find(option => option.value === newContainer.agent_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                agent_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >აგენტი</label> 
                </div>
 

                 

                <div className={cl.groupInput}>
                    <Select
                        styles={validates && validates.status_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={appState.container_statuses}
                         
                        value={appState.container_statuses.find(option => option.value === newContainer.status_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                status_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                        placeholder="სტატუსი"
                        isDisabled={!app.hasPermission("CHANGE_STATUS")}
                    />
                    <label>სტატუსი</label>

                </div>

               
            </div>

            <div className={cl.containerItem} style={{ marginBottom: '0' }}>

                <div className={cl.groupInput}>
                    <DistatntionSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newContainer.sender_country_id}
                        childId={newContainer.sender_city_id}
                        isNetwork={true}
                        styles={selectDistatntionStyle}
                        onChange={async (sender_country_id, sender_city_id) => { 
                            setNewContainer(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        label="გამოსვლის პორტი"
                        placeholder="- -"
                        placeholderSub="- - - - "
                        validate={validates && validates.sender_country_id ? true : false}
                        validateSub={validates && validates.sender_city_id ? true : false}
                    />
                </div>

                <div className={cl.groupInput}>
                    <DistatntionSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newContainer.reciever_country_id}
                        childId={newContainer.reciever_city_id}
                        isNetwork={true}
                        styles={selectDistatntionStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        label="შემოსვლის პორტი"
                        placeholder="- -"
                        placeholderSub="- - - -"
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    /> 
                </div>

                <div className={cl.groupInput} style={{ display: 'flex', gap: '5px' }}>

                    <div className={cl.groupInput  }>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" style={{fontWeight: '600' , paddingInlineStart: '23px'}}
                                className={validates && validates.gross_weight ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus}  onBlur={handleBlur}  onKeyPress={handleKeyPress} id="gross_weight" name="gross_weight" value={newContainer.gross_weight} onChange={handleContainerChangeInt}   autoComplete="off" />
                                <div className={cl.crmIcon}>
                                <Kilogram   />  
                                </div>
                        </div>
                        <label htmlFor="gross_weight">წონა</label>
                    </div>


                    <div className={cl.groupInput }>
                        <div className={cl.groupBorder}>
                            
                            <input
                                type="checkbox"
                                checked={newContainer.is_transit === 1}
                                onChange={(event) => {
                                    setNewContainer(prevState => ({
                                    ...prevState,
                                    is_transit: event.target.checked ? 1 : 0,
                                    }));
                                }}
                                />   კი  
                            <label >ტრანზიტი</label>
                        </div>
                    </div>



                </div>


                <div className={cl.groupInput}>
                    <DistatntionSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newContainer.final_destination_country_id}
                        childId={newContainer.final_destination_city_id}
                        isNetwork={true}
                        styles={selectDistatntionStyle}
                        onChange={async (final_destination_country_id, final_destination_city_id) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                final_destination_country_id: final_destination_country_id ? final_destination_country_id : 0,
                                final_destination_city_id: final_destination_city_id ? final_destination_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        label="ფინალური დანიშ."
                        placeholder="- -"
                        placeholderSub="- - - -"
                        validate={validates && validates.final_destination_country_id ? true : false}
                        validateSub={validates && validates.final_destination_city_id ? true : false}
                        isDisabled={newContainer.is_transit && newContainer.is_transit == 1 ? false : true}
                    /> 
                </div>




                <div className={validates && validates.land_type_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <Select
                        styles={validates && validates.land_type_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={typeOptions}
                        placeholder=""
                        isClearable
                        value={typeOptions.find(option => option.value === newContainer.land_type_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                land_type_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >სახმელეთო გადაზიდვა </label>
                </div>





                <div className={cl.groupInput}>
                    <DateSelect
                        defDate={newContainer.send_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                send_at: date ? date : "",
                            }));
                        }
                        }
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input  }
                        isClearable={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? app.hasPermission("CHANGE_SEND_AT")
                                : app.hasPermission("ADD_SEND_AT")
                        }
                        isDisabled={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? !app.hasPermission("CHANGE_SEND_AT")
                                : !app.hasPermission("ADD_SEND_AT")
                        }
 
                    />
                    <label >გამოსვლა</label>

                </div>

                <div className={cl.groupInput}>
                    
                    <DateSelect
                        defDate={newContainer.entry_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                entry_at: date ? date : "",
                            }));
                        }
                        }
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input  }
                        isClearable={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? app.hasPermission("CHANGE_ENTRY_AT")
                                : app.hasPermission("ADD_ENTRY_AT")
                        }
                        isDisabled={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? !app.hasPermission("CHANGE_ENTRY_AT")
                                : !app.hasPermission("ADD_ENTRY_AT")
                        }

                    />
                    <label >შემოსვლა</label>

                </div>


 

 


                <div className={cl.groupInput}>
                    
                    <DateSelect
                        defDate={newContainer.open_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                open_at: date ? date : "",
                            }));
                        }
                        }
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input  }
                        isClearable={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? app.hasPermission("CHANGE_OPEN_AT")
                                : app.hasPermission("ADD_OPEN_AT")
                        }
                        isDisabled={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? !app.hasPermission("CHANGE_OPEN_AT")
                                : !app.hasPermission("ADD_OPEN_AT")
                        }
 
                    />
                    <label >გახსნა</label>

                </div>

                <div className={cl.groupInput}>
                    
                    <DateSelect
                        defDate={newContainer.taken_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                taken_at: date ? date : "",
                            }));
                        }
                        }
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input  }
                        isClearable={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? app.hasPermission("CHANGE_TAKEN_AT")
                                : app.hasPermission("ADD_TAKEN_AT")
                        }
                        isDisabled={
                            newContainer.entry_at && newContainer.entry_at.length > 6
                                ? !app.hasPermission("CHANGE_TAKEN_AT")
                                : !app.hasPermission("ADD_TAKEN_AT")
                        }

 
                    />
                    <label>დასრულება</label>

                </div>

                <div className={cl.groupInput}>
                 
                </div>

                 
   

  
            </div>

            <div className={cl.containerItem} style={{ display: 'none', marginBottom: '15px' }}>
   
                     <>
 
                        <div   className={cl.groupInput + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.frast_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="frast_price" name="frast_price" value={newContainer.frast_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="frast_price">ფრახტი</label>
                        </div>

                        <div   className={cl.groupInput + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.thc_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="thc_price" name="thc_price" value={newContainer.thc_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="thc_price">THC ფასი</label>
                        </div>

                        <div   className={cl.groupInput + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="other_price" name="other_price" value={newContainer.other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="other_price">სხვა</label>
                        </div>
 
                        <div   className={cl.groupInput }>  </div>


                        <div   className={cl.groupInput + ' ' + cl.blue + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.client_frast_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="client_frast_price" name="client_frast_price" value={newContainer.client_frast_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="client_frast_price">ფრახტი</label>
                        </div>

                        <div  className={cl.groupInput + ' ' + cl.blue + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.client_thc_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="client_thc_price" name="client_thc_price" value={newContainer.client_thc_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="client_thc_price">THC ფასი</label>
                        </div>

                        <div   className={cl.groupInput + ' ' + cl.blue + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.client_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="client_other_price" name="client_other_price" value={newContainer.client_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="client_other_price">სხვა</label>
                        </div> 


                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div> 
                        <div className={cl.groupInput }></div> 
                        <div className={cl.groupInput }></div> 
                       

                    </>
  

            </div>
 
            {newContainer.land_type_id === 0 ? (
                  <></> 

            ) : (
   
                <div className={cl.containerItem} style={{ display: 'none', marginBottom: '0', marginBottom: '0' }}>
                      

                        <div className={cl.groupInput + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.land_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="land_price" name="land_price" value={newContainer.land_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="land_price"> სახმელეთო</label>
                        </div>

                        <div className={cl.groupInput + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.company_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="land_other_price" name="land_other_price" value={newContainer.land_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="company_other_price">სხვა </label>
                        </div>
  
                        <div className={cl.groupInput}></div>
                        <div className={cl.groupInput}></div>
                        <div className={cl.groupInput}></div>

                        <div className={cl.groupInput + ' ' + cl.blue + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.client_land_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="client_land_price" name="client_land_price" value={newContainer.client_land_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="client_land_price">სახმელეთო</label>
                        </div>

                        <div className={cl.groupInput + ' ' + cl.blue + ' ' + cl.dollar}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.client_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                    onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                    id="client_land_other_price" name="client_land_other_price" value={newContainer.client_land_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <USD />
                                </div>
                            </div>
                            <label htmlFor="client_other_price">სხვა</label>
                        </div>
 
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>  
                        <div className={cl.groupInput }></div> 
      
                </div>

            )}


            <div className={cl.containerItem} style={{ display: 'flex', marginBottom: '0px', marginTop: '10px' }}>
                <div className={cl.groupInput } ></div>
                <div className={cl.groupInput } ></div>
                <div className={cl.groupInput } ></div>
                <div className={cl.groupInput } ></div>
                <div className={cl.groupInput } ></div>
                <div className={cl.groupInput } ></div>

                <div className={cl.groupInput + ' ' + cl.dollar}>
                    <span  className={cl.CancelBtn} onClick={onCloseEdit}>გაუქმება</span>
                </div>

                <div className={cl.groupInput + ' ' + cl.dollar}>
                    <span onClick={saveHandle} className={cl.YesBtn}>შენახვა</span>
                </div>
            </div>

        </>
    );

};

export default EditContainerModal;